import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import Spinner from "./Spinner";
import { minDelay } from "../util";
import { useConfig } from "../ConfigContext";

const CaseLookup = forwardRef(({ onCaseLookup, onLookupBusy, onReset, caseNumParam, plateParam }, ref) => {
  const {config, configError} = useConfig();
  const [caseNumber, setCaseNumber] = useState(caseNumParam);
  const [casePlateNumber, setCasePlateNumber] = useState(plateParam);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [penaltyNotFound, setPenaltyNotFound] = useState(false);
  const [isQuerying, setIsQuerying] = useState(false);

  const handleSubmit = (event) => {
    if(event) event.preventDefault(); // Prevents the page from refreshing on form submission
    // basic validation
    if(!caseNumber || !casePlateNumber){
      setShowValidationErrors(true);
      return;
    }
    setIsQuerying(true);
    let caseNumberStripped = caseNumber.replace(/[^a-zA-Z0-9]/g, "");
    let casePlateNumberStripped = casePlateNumber.replace(/[^a-zA-Z0-9]/g, "");

    //use minimum delay so the loading indicator doesn't flash too fast
    minDelay(
      fetch(
        `${config.apiUrl}/case?case-number=${caseNumberStripped}&case-plate-number=${casePlateNumberStripped}`,
        {
          headers: {
            "Api-Key": config.apiKey,
          },
        }
      ),
      1000
    )
      .then((response) => {
        if (response.status === 200) return response.json();
        else if(response.status === 204) return null;
      })
      .then((caseData) => {
        if(caseData) { 
          setPenaltyNotFound(false);
          onCaseLookup(caseData);
        }
        else setPenaltyNotFound(true);
        setIsQuerying(false);
      })
      .catch((e) => {
        console.error(e);
        setIsQuerying(false);
      });
  };

  const resetForm = () => {
    setCaseNumber("");
    setCasePlateNumber("");
    setShowValidationErrors(false);
    setPenaltyNotFound(false);
    onReset();
  };

  // Expose the reset function using `useImperativeHandle`
  useImperativeHandle(ref, () => ({
    resetForm, 
  }));

  useEffect(() => {
    if(caseNumParam && plateParam){
      handleSubmit(null);
    }
  }, []);

  return (
    <div className="path-webform">
      <form
        className="webform-submission-form webform-submission-add-form webform-submission-test-form webform-submission-test-add-form js-webform-details-toggle webform-details-toggle antibot contextual-region"
        onSubmit={handleSubmit}
      >
        <div className="webform-flexbox js-webform-flexbox js-form-wrapper form-wrapper">
          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <div className="js-form-item form-item js-form-type-textfield form-type-textfield">
                <label className="form-item__label form-required" htmlFor="caseNumber">Penalty Order Number</label>
                <input
                  type="text"
                  name="caseNumber"
                  id="caseNumber"
                  value={caseNumber}
                  onChange={(e) => setCaseNumber(e.target.value)}
                   autoComplete="off"
                  className="js-webform-input-mask form-text form-element form-element--type-text form-element--api-textfield"
                />
                {showValidationErrors && !caseNumber && <div className="error">Penalty order number is required</div>}
              </div>
            </div>
          </div>

          <div className="webform-flex webform-flex--1">
            <div className="webform-flex--container">
              <div className="js-form-item form-item js-form-type-textfield form-type-textfield">
                <label className="form-item__label form-required" htmlFor="casePlateNumber">License Plate Number</label>
                <input
                  type="text"
                  name="casePlateNumber"
                  id="casePlateNumber"
                  value={casePlateNumber}
                  onChange={(e) => setCasePlateNumber(e.target.value)}
                   autoComplete="off"
                  className="js-webform-input-mask form-text form-element form-element--type-text form-element--api-textfield"
                />
                {showValidationErrors && !casePlateNumber && <div className="error">License plate number is required</div>}
              </div>
            </div>
          </div>
        </div>

        { penaltyNotFound && 
        <div className="webform-flex--1 js-form-item form-item js-form-type-textfield form-type-textfield">
          <div className="error">A penalty order with this number and license plate number was not found</div>
        </div>
        }

        <div className="webform-flex--1 js-form-item form-item js-form-type-textfield form-type-textfield">
          <button
            className="webform-flex--1 webform-button--submit button button--primary js-form-submit form-submit"
            type="submit"
            disabled={isQuerying}
          >
            {isQuerying ? "Searching . . . ." : "Lookup Penalty Order"}
          </button>
          <button
            className="btn btn-secondary webform-flex--1 webform-button--submit js-form-submit form-submit"
            type="reset"
            onClick={resetForm}
          >
            Reset Form
          </button>
        </div>
      </form>
    </div>
  );
});

export default CaseLookup;
